<template>
    <div id="main">
        <div class="commonContent" :style="pageContent">
            <div id="home-survey" ref="homeSurveyRef">
                <el-container style="height: 100%">
                    <el-header style="height: auto">
                        <el-row class="statistics" :gutter="24">
                            <el-col :span="8" title="未派单" v-if="notNormalRole">
                                <el-card class="statistics-card" shadow="hover">
                                    <div class="today-statistics">
                                        <p class="today-number">{{unDispatchCnt}}</p>
                                        <p class="title-tip">未派单</p>
                                    </div>
                                    <div class="total-statistics">
                                        <div class="total-img">
                                            <img class="total-img-hotel" src="@/assets/images/main/todatCount@2x.png" />
                                        </div>
                                    </div>
                                </el-card>
                            </el-col>
                            <el-col :span="8" title="未接单" v-if="notNormalRole">
                                <el-card class="statistics-card" shadow="hover">
                                    <div class="today-statistics">
                                        <p class="today-number">{{unAcceptCnt}}</p>
                                        <p class="title-tip">未接单</p>
                                    </div>
                                    <div class="total-statistics">
                                        <div class="total-img">
                                            <img class="total-img-hotel" src="@/assets/images/main/monthCount@2x.png" />
                                        </div>
                                    </div>
                                </el-card>
                            </el-col>
                            <el-col :span="totalSpan" title="报修单总数">
                                <el-card class="statistics-card" shadow="hover">
                                    <div class="today-statistics">
                                        <p class="today-number">{{totalCnt}}</p>
                                        <p class="title-tip">报修单总数</p>
                                    </div>
                                    <div class="total-statistics">
                                        <div class="total-img">
                                            <img class="total-img-hotel" src="@/assets/images/main/yearCount@2x.png" />
                                        </div>
                                    </div>
                                </el-card>
                            </el-col>
                        </el-row>

                        <el-row class="middle-content" :gutter="24">
                            <el-col :span="12">
                                <el-card shadow="hover">
                                    <div class="content-left">
                                        <div class="content-left-img">
                                            <img v-if="headImgShow" class="content-left-headImg" :src="headImg" />
                                            <img v-else class="content-left-headImg" src="@/assets/images/main/headImg.png" />
                                        </div>
                                    </div>
                                    <div class="content-right">
                                        <p class="content-right-details">账号：{{userName}}</p>
                                        <p class="content-right-details">姓名：{{realName}}</p>
                                        <p class="content-right-details">组织：{{deptName}}</p>
                                        <p class="content-right-bottom">上次登录：{{lastLoginAt}}</p>
                                    </div>
                                </el-card>
                            </el-col>
                            <el-col :span="12">
                                <el-card shadow="hover">
                                    <div class="content-left">
                                        <div class="content-left-logo">
                                            <img class="content-left-logo-img" src="@/assets/images/main/flower.png" />
                                        </div>
                                    </div>
                                    <div class="content-right">
                                        <p class="content-right-tips-top">当前时间：{{realTime}}</p>
                                        <p class="content-right-tips-bottom">{{changeTips(realTime)}}</p>
                                    </div>
                                </el-card>
                            </el-col>
                        </el-row>
                    </el-header>

                    <el-main style="height: 100%;padding: 10px 20px 0px 20px;">
                        <div class="untreated-list" ref="untreatedListRef">
                            <div class="commonTable">
                                <el-table ref="multipleTable" :data="returnData" height="100%" width="100%" v-loading="loading" element-loading-text="拼命加载中" size="medium">
                                    <el-table-column label="报修单号" min-width="130">
                                        <template slot-scope="scope">
                                            <el-link type="primary" @click="toOrderView(scope.row)">{{scope.row.repaircode}}</el-link>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="regionName" label="学生校区" min-width="80"> </el-table-column>
                                    <el-table-column prop="faulttypeName" label="故障类型" min-width="120"> </el-table-column>
                                    <el-table-column prop="statusName" label="状态" min-width="80"> </el-table-column>

                                    <el-table-column prop="ostatus" label="派单状态" min-width="80">
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.ostatus == null">未派单</span>
                                            <span v-if="scope.row.ostatus == 1">已派单</span>
                                            <span v-if="scope.row.ostatus == 2">已接单</span>
                                            <span v-if="scope.row.ostatus == 3">已完成</span> </template>
                                    </el-table-column>
                                    <el-table-column prop="repersonnel" label="接单人员" min-width="150"> </el-table-column>
                                    <el-table-column prop="createdate" label="报修时间" min-width="150"> </el-table-column>
                                </el-table>
                            </div>
                            <div class="commonPage">
                                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="cur_page" :page-sizes="[5, 10, 15, 30]" layout="total, sizes, prev, pager, next, jumper" :total="totalCount"></el-pagination>
                            </div>
                        </div>
                    </el-main>
                </el-container>
            </div>
        </div>
    </div>
</template>

<script>
import SettingApi from "@/api/setting.js";
import HomeApi from "@/api/home.js";
import TabResize from "@/utils/TabResize.js";
import FaultApi from "@/api/fault.js";

export default {
    mixins: [TabResize],

    data () {
        return {
            notNormalRole: true,
            totalSpan: 8,

            unDispatchCnt: 0,
            unAcceptCnt: 0,
            totalCnt: 0,

            headImgShow: false,
            headImg: "",

            showRefresh: false,
            sysClick: false,
            bussinessClick: false,
            choseValue: "1",
            userName: "",
            realName: "",
            deptName: "",
            lastLoginAt: "",
            refreshBtn: false,
            realTime: "",
            dayCount: "",
            monthCount: "",
            yearCount: "",
            cur_page: 1,
            tableData: [],
            returnData: [],
            loading: true,
            startDate: "",
            endDate: "",
            logType: "1",
            platformType: "",
            cur_page: 1,
            per_page: 10,
            totalCount: 0,
            form: {},
            rules: {}
        };
    },

    mounted () {
        this.$nextTick(() => {
            this.sysClick = true;
            this.getUserInfo();
            this.initData();
            this.getDayOnlineCount();

            // 页面加载完后显示当前时间
            this.realTime = this.dealWithTime(new Date());
            // 定时刷新时间
            let _this = this;
            // 定时器
            this.timer = setInterval(function () {
                _this.realTime = _this.dealWithTime(new Date()); // 修改数据date
            }, 1000);
        });
    },

    methods: {
        loadImage (userIcon) {
            this.headImgShow = false;

            let imgId = userIcon;
            if (!imgId || imgId == "undefined") {
                return;
            }
            HomeApi.getClass()
                .downloadFile(imgId)
                .then(resp => {
                    let _data = resp.data;
                    if (_data) {
                        this.headImg = URL.createObjectURL(_data);
                    } else {
                        this.headImgShow = true;
                    }
                }).catch(err => {
                    this.headImgShow = true;
                });
        },

        handleSizeChange (val) {
            this.per_page = val;
            this.loading = true;
            this.initData();
        },
        handleCurrentChange (val) {
            this.cur_page = val;
            this.loading = true;
            this.initData();
        },

        getUserInfo () {
            SettingApi.getClass()
                .getUserInfo()
                .then(resp => {
                    if (this.$constant.BIZ_RESPONSE_CODE == resp.data.code) {
                        let data = resp.data.data;
                        this.userName = data.userName;
                        this.realName = data.realName;
                        this.lastLoginAt = data.lastLoginAt;
                        this.deptName = data.deptName;
                        this.loadImage(data.userIcon);

                        // 普通用户只显示“报修单总数”
                        this.notNormalRole = true;
                        this.totalSpan = 8;
                        if ("admin" != this.userName) {
                            let roleVos = data.roleVos;
                            if (roleVos.length > 0) {
                                let isNormal = true;
                                for (let i = 0; i < roleVos.length; i++) {
                                    if ("MANAGER" == roleVos[i].code || "ENGINEER" == roleVos[i].code) {
                                        isNormal = false;
                                        break;
                                    }
                                }
                                if (isNormal) {
                                    this.notNormalRole = false;
                                    this.totalSpan = 24;
                                }
                            }
                        }
                    } else {
                        this.$message.error(resp.data.msg);
                        return false;
                    }
                }).catch(err => {
                    this.$message.error(err);
                    return false;
                });
        },

        getDayOnlineCount () {
            SettingApi.getClass()
                .getDayOnlineCount()
                .then(resp => {
                    if (this.$constant.BIZ_RESPONSE_CODE == resp.data.code) {
                        let data = resp.data.data;
                        this.dayCount = data.dayCount;
                        this.monthCount = data.monthCount;
                        this.yearCount = data.yearCount;
                    } else {
                        this.$message.error(resp.data.msg);
                        return false;
                    }
                }).catch(err => {
                    this.$message.error(err);
                    return false;
                });
        },

        //报修列表
        initData () {
            this.returnData = [];
            let param = {
                pageNum: this.cur_page,
                pageSize: this.per_page
            };

            FaultApi.getClass()
                .getDashboardOrderCnt()
                .then((resp) => {
                    if (this.$constant.BIZ_RESPONSE_CODE == resp.data.code) {
                        let data = resp.data.data;

                        this.totalCnt = data.total;
                        this.unDispatchCnt = data.undispatchcnt;
                        this.unAcceptCnt = data.unacceptcnt;
                    } else {
                        this.$message.error(resp.data.msg);
                    }
                }).catch((err) => {
                    this.$message.error(err);
                });

            FaultApi.getClass()
                .findPages(param)
                .then((resp) => {
                    if (this.$constant.BIZ_RESPONSE_CODE == resp.data.code) {
                        this.totalCount = resp.data.data.totalElements;
                        this.returnData = resp.data.data.data;
                    } else {
                        this.$message.error(resp.data.msg);
                    }
                }).catch((err) => {
                    this.$message.error(err);
                });

            this.loading = false;
        },

        forwardDate (days, date) {
            //解决浏览器兼容问题
            date = date.replace(new RegExp(/-/gm), "/");
            let curDate = new Date(date);
            let myDate = new Date(curDate.getTime() - 24 * days * 60 * 60 * 1000);
            let res = myDate.getFullYear() + "-" + this.appendZero(myDate.getMonth() + 1) + "-" + this.appendZero(myDate.getDate());
            return res;
        },

        appendZero (obj) {
            if (obj < 10) {
                return "0" + obj;
            } else {
                return obj;
            }
        },

        dealWithTime (data) {
            let formatDateTime;
            let Y = data.getFullYear();
            let M = data.getMonth() + 1;
            let D = data.getDate();
            let H = data.getHours();
            let Min = data.getMinutes();
            let S = data.getSeconds();
            let W = data.getDay();
            H = H < 10 ? "0" + H : H;
            Min = Min < 10 ? "0" + Min : Min;
            S = S < 10 ? "0" + S : S;
            switch (W) {
                case 0:
                    W = "天";
                    break;
                case 1:
                    W = "一";
                    break;
                case 2:
                    W = "二";
                    break;
                case 3:
                    W = "三";
                    break;
                case 4:
                    W = "四";
                    break;
                case 5:
                    W = "五";
                    break;
                case 6:
                    W = "六";
                    break;
                default:
                    break;
            }
            formatDateTime = Y + "年" + M + "月" + D + "日 " + H + ":" + Min + ":" + S + " 星期" + W;
            return formatDateTime;
        },

        // 注意在vue实例销毁前，清除我们的定时器。
        destroyed () {
            if (this.timer) {
                clearInterval(this.timer);
            }
        },
        refreshData () {
            this.showRefresh = true;
            this.loading = true;
            this.initData();
        },

        changeTips () {
            let newDate = new Date();
            if (newDate.getHours() >= 6 && newDate.getHours() < 8) {
                return "早上好，喝咖啡开始一天的工作吧";
            } else if (newDate.getHours() >= 8 && newDate.getHours() < 12) {
                return "上午好，喝咖啡开始一天的工作吧";
            } else if (newDate.getHours() >= 12 && newDate.getHours() < 18) {
                return "下午好，喝咖啡开始一天的工作吧";
            } else if (newDate.getHours() >= 18 && newDate.getHours() < 24) {
                return "晚上好，喝咖啡开始一天的工作吧";
            } else {
                return "夜深了，喝咖啡开始一天的工作吧";
            }
        },

        getSelectedTime () {
            this.initData();
        },

        toOrderView (row) {
            this.$router.push({
                name: "OrderView-2",
                params: { row }
            });
        },

        changeType (val) {
            this.choseValue = val;
            if (val == "1") {
                this.sysClick = true;
                this.bussinessClick = false;
                this.logType = 1;
            } else {
                this.bussinessClick = true;
                this.sysClick = false;
                this.logType = 2;
            }
            this.initData();
        }
    }
};
</script>

<style lang="stylus" scoped>
#main >>> .el-card__body {
    display: flex;
}

#main {
    font-family: PingFang-SC-Regular, PingFang-SC, MicrosoftYaHei;

    .commonContent {
        background-color: transparent;
        padding: 0px;
    }

    .commonPage {
        width: 100%;
        background-color: #fff;
    }

    padding: 0px;
}

#home-survey >>> .el-card__body {
    padding: 0 !important;
}

#home-survey >>> .el-table {
    font-size: 11px;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
}

#home-survey >>> .el-table thead {
    font-size: 12px;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
}

#home-survey {
    height: 100%;

    .statistics {
        .el-card, .el-message {
            margin-top: 10px;
            height: 115px;
        }

        .statistics-card {
            padding: 0 16.98% 0 12.4%;

            .today-statistics {
                flex: 1;

                .today-number {
                    margin-top: 35px;
                    font-size: 28px;
                    font-weight: 400;
                    color: #282D32;
                    line-height: 23px;
                }

                .title-tip {
                    margin-top: 10px;
                    font-size: 18px;
                    font-weight: 400;
                    color: #282D32;
                    line-height: 23px;
                }
            }

            .total-statistics {
                .total-img {
                    margin-top: 35px;
                    overflow: hidden;
                }

                .total-img-hotel {
                    left: -51px;
                    width: 51px;
                    height: 51px;
                    filter: drop-shadow(51px 0px 0px $theme-color);
                }
            }
        }
    }

    .middle-content {
        display: flex;
        margin-top: 12px;

        .el-card, .el-message {
            height: 189px;
        }

        .content-left {
            .content-left-img {
                margin-left: 13%;
                margin-top: 20px;
                width: 192px;
                height: 192px;
            }

            .content-left-headImg {
                width: 150px;
                height: 150px;
            }

            .content-left-logo {
                margin-top: 60px;
                margin-left: 45px;
                overflow: hidden;
            }

            .content-left-logo-img {
                left: -60px;
                width: 60px;
                height: 60px;
                filter: drop-shadow(60px 0px 0px $theme-color);
            }
        }

        .content-right {
            flex: 1;
            padding-right: 6%;
            padding-left: 1.5%;
            margin-top: 12px;

            .content-right-details {
                margin-top: 15px;
                font-size: 14px;
                font-weight: 400;
                color: #282D32;
                line-height: 23px;
                text-align: left;
            }

            .content-right-bottom {
                margin-top: 12px;
                font-size: 12px;
                font-weight: 400;
                color: #757575;
                line-height: 23px;
                text-align: left;
            }

            .content-right-tips-top {
                margin-left: 10px;
                margin-top: 50px;
                font-size: 16px;
                font-weight: 400;
                color: #282D32;
                line-height: 23px;
                text-align: left;
            }

            .content-right-tips-bottom {
                margin-left: 10px;
                margin-top: 5px;
                font-size: 16px;
                font-weight: 400;
                color: #282D32;
                line-height: 23px;
                text-align: left;
            }
        }
    }

    .untreated-list {
        height: 100%;
        background-color: #fff;

        .list-header {
            height: 40px;
            padding-top: 10px;

            .list-header-title {
                float: left;
                height: 23px;
                margin-left: 22px;
                margin-top: 10px;
                font-size: 20px;
                font-weight: 400;
                color: #282D32;
                line-height: 20px;
            }

            .list-header-refresh {
                float: left;
                margin-left: 15px;
                margin-top: 12px;

                img {
                    width: 12px;
                    height: 12px;
                }
            }
        }

        .commonTable {
            padding: 0 10px 0 10px;
            height: calc(100% - 50px);

            .el-table thead {
                color: green !important;
            }
        }

        .pageButton {
            float: right;
            margin-right: 20px;
        }

        .pageButton>>>.el-button {
            border-radius: 0px !important;
            border: 1px solid rgba(151, 151, 151, 1);
        }

        .button-style {
            background-color: $theme-color;
        }

        .clickStyle {
            width: 55px;
            height: 30px;
            background-color: $theme-color;
            color: white;
        }

        .noClickStyle {
            width: 55px;
            height: 30px;
            background-color: white;
            color: black;
        }

        .theme-color {
            color: $theme-color;
        }
    }
}
</style>